﻿(function() {
  'use strict';

  window.CartRewardsUnified = true;

  var STORAGE_KEY_MINI = 'cart_reward_mini_gift';
  var STORAGE_KEY_MYSTERY = 'cart_reward_mystery_enabled';
  
  var config = {
    miniThreshold: 0,
    mysteryThreshold: 0,
    freeShippingThreshold: 0,
    miniGiftProductIds: new Set(),
    mysteryGiftProductId: null
  };

  function log() {
    console.log('[Cart Rewards]', ...arguments);
  }

  function getStorage(key) {
    try {
      return localStorage.getItem(key);
    } catch (e) {
      return null;
    }
  }

  function setStorage(key, val) {
    try {
      localStorage.setItem(key, val);
    } catch (e) {}
  }

  function getCartTotal(cart) {
    if (!cart || !cart.items) return 0;
    
    var total = 0;
    cart.items.forEach(function(item) {
      var isGift = config.miniGiftProductIds.has(item.product_id) || 
                   item.product_id === config.mysteryGiftProductId;
      if (!isGift) {
        total += item.final_line_price;
      }
    });
    
    return total;
  }

  function hasGiftInCart(cart, productId) {
    if (!cart || !cart.items) return false;
    return cart.items.some(function(item) {
      return item.product_id === productId;
    });
  }

  function getGiftKey(cart, productId) {
    if (!cart || !cart.items) return null;
    var item = cart.items.find(function(i) { 
      return i.product_id === productId; 
    });
    return item ? item.key : null;
  }

  function fetchCart() {
    return fetch('/cart.js', {
      credentials: 'include'
    }).then(function(r) { return r.json(); });
  }

  function removeCartItem(key) {
    return fetch('/cart/change.js', {
      method: 'POST',
      credentials: 'include',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ id: key, quantity: 0 })
    }).then(function(r) { return r.json(); });
  }

  function addCartItem(variantId) {
    return fetch('/cart/add.js', {
      method: 'POST',
      credentials: 'include',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ 
        items: [{ id: variantId, quantity: 1 }] 
      })
    }).then(function(r) { return r.json(); });
  }

  function loadConfig() {
    log('Загрузка конфигурации...');
    
    var progressBar = document.querySelector('[data-cart-rewards-progress]');
    if (progressBar) {
      config.miniThreshold = parseFloat(progressBar.dataset.miniThreshold) || 0;
      config.mysteryThreshold = parseFloat(progressBar.dataset.mysteryThreshold) || 0;
      config.freeShippingThreshold = parseFloat(progressBar.dataset.freeShippingThreshold) || 0;
    } else {
      log('⚠️ Progress bar не найден');
    }

    config.miniGiftProductIds.clear();
    
    var miniItems = document.querySelectorAll('[data-reward-type="mini_gift"] [data-product-id]');
    miniItems.forEach(function(el) {
      var id = parseInt(el.dataset.productId);
      if (id) config.miniGiftProductIds.add(id);
    });

    var mysteryScript = document.querySelector('[data-mystery-product-id]');
    if (mysteryScript) {
      config.mysteryGiftProductId = parseInt(mysteryScript.dataset.mysteryProductId) || null;
    }

    log('Конфигурация:', {
      freeShippingThreshold: config.freeShippingThreshold,
      miniThreshold: config.miniThreshold,
      mysteryThreshold: config.mysteryThreshold,
      miniProducts: Array.from(config.miniGiftProductIds),
      mysteryProduct: config.mysteryGiftProductId
    });

    return config.miniThreshold > 0 || config.mysteryThreshold > 0;
  }

  function watchForRewards() {
    var progressBar = document.querySelector('[data-cart-rewards-progress]');
    if (progressBar) {
      log('✓ Progress bar найден сразу');
      return;
    }

    log('Progress bar не найден, запускаем observer...');
    
    var observer = new MutationObserver(function(mutations) {
      var progressBar = document.querySelector('[data-cart-rewards-progress]');
      if (progressBar) {
        log('✓ Progress bar появился в DOM');
        observer.disconnect();
        
        if (loadConfig()) {
          initDrawer();
          initMysteryToggle();
          fetchCart().then(updateUI);
        }
      }
    });

    observer.observe(document.body, {
      childList: true,
      subtree: true
    });
  }

  function updateUI(cart) {
    if (!cart) return;
    
    var total = getCartTotal(cart);
    log('Обновление UI, total:', total);

    checkAndRemoveInvalidGifts(cart, total);

    updateProgress(total);
    updateRewardItems(total);
    
    resetCheckoutButton();
  }
  
  function resetCheckoutButton() {
    var checkoutBtn = document.querySelector('[data-checkout-button]');
    if (!checkoutBtn) return;
    
    var rewardsContainer = checkoutBtn.closest('[data-cart-rewards]');
    var addingGiftsText = rewardsContainer ? rewardsContainer.getAttribute('data-text-adding-gifts') : '';
    var checkoutText = rewardsContainer ? rewardsContainer.getAttribute('data-text-checkout') : '';
    
    if (checkoutBtn.disabled) {
      var form = checkoutBtn.closest('form');
      if (form) {
        var isBlockedByScript = checkoutBtn.textContent === addingGiftsText || 
                                 checkoutBtn.getAttribute('data-original-text');
        
        if (isBlockedByScript) {
          if (!isProcessingCheckout) {
            checkoutBtn.disabled = false;
            var originalText = checkoutBtn.getAttribute('data-original-text') || checkoutText;
            checkoutBtn.textContent = originalText.trim();
            checkoutBtn.removeAttribute('data-original-text');
            log('Кнопка checkout разблокирована');
          }
        }
      }
    }
  }

  function checkAndRemoveInvalidGifts(cart, total) {
    var giftsToRemove = [];
    var shouldClearMiniSelection = false;

    if (total < config.miniThreshold) {
      cart.items.forEach(function(item) {
        if (config.miniGiftProductIds.has(item.product_id)) {
          log('⚠️ Mini gift в корзине, но цена ниже threshold - удаляем');
          giftsToRemove.push(item.key);
          shouldClearMiniSelection = true;
        }
      });
    }

    if (total < config.mysteryThreshold && config.mysteryGiftProductId) {
      cart.items.forEach(function(item) {
        if (item.product_id === config.mysteryGiftProductId) {
          log('⚠️ Mystery gift в корзине, но цена ниже threshold - удаляем');
          giftsToRemove.push(item.key);
        }
      });
    }

    if (giftsToRemove.length > 0) {
      log('Удаляем', giftsToRemove.length, 'невалидных подарков...');
      
      if (shouldClearMiniSelection) {
        setStorage(STORAGE_KEY_MINI, '');
      }
      
      Promise.all(
        giftsToRemove.map(function(key) {
          return removeCartItem(key);
        })
      ).then(function() {
        log('✓ Невалидные подарки удалены');
        return fetchCart();
      }).then(function(updatedCart) {
        var newTotal = getCartTotal(updatedCart);
        updateProgress(newTotal);
        updateRewardItems(newTotal);
      }).catch(function(err) {
        log('Ошибка при удалении подарков:', err);
      });
    }
  }

  function updateProgress(total) {
    var bars = document.querySelectorAll('[data-cart-rewards-progress]');
    if (!bars.length) return;

    var maxThreshold = Math.max(config.freeShippingThreshold, config.miniThreshold, config.mysteryThreshold);
    var percent = maxThreshold > 0 ? Math.min((total / maxThreshold) * 100, 100) : 0;

    bars.forEach(function(bar) {
      var barEl = bar.querySelector('[data-rewards-bar]');
      if (barEl) {
        barEl.style.setProperty('--progress-width', percent + '%');
        var barFill = barEl.querySelector('.cart-rewards-progress__bar-fill');
        if (barFill) {
          barFill.style.width = percent + '%';
        }
      }

      var milestones = bar.querySelectorAll('[data-milestone]');
      milestones.forEach(function(m) {
        var threshold = parseFloat(m.dataset.threshold) || 0;
        m.setAttribute('data-achieved', total >= threshold ? 'true' : 'false');
      });

      updateMessage(total, bar);
    });
  }

  function updateMessage(total, bar) {
    var messageElement = bar.querySelector('[data-message-text]');
    if (!messageElement) return;

    var hasFreeShipping = total >= config.freeShippingThreshold;
    var hasMini = total >= config.miniThreshold;
    var hasMystery = total >= config.mysteryThreshold;

    var messageText = '';

    function formatRemaining(remaining) {
      return (remaining / 100).toFixed(2).replace('.', ',');
    }

    function buildSpendMoreText(remaining, label) {
      var spendMoreText = bar.getAttribute('data-text-spend-more') || '';
      var remainingFormatted = formatRemaining(remaining);

      return spendMoreText
        .replace(/\{\{\s*amount\s*\}\}/g, remainingFormatted)
        .replace(/\{\s*amount\s*\}/g, remainingFormatted)
        .replace(/\{\{\s*reward\s*\}\}/g, label)
        .replace(/\{\s*reward\s*\}/g, label);
    }

    if (hasMystery) {
      messageText = bar.getAttribute('data-text-all-unlocked') || '';
    }
    else if (hasMini) {
      var remaining = config.mysteryThreshold - total;
      var mysteryMilestone = bar.querySelector('[data-milestone="mystery-gift"]');
      var label = mysteryMilestone ? mysteryMilestone.getAttribute('data-label') || '' : '';
      var spendMoreMysteryText = buildSpendMoreText(remaining, label);

      messageText = spendMoreMysteryText;
    }
    else if (hasFreeShipping) {
      var miniMilestone = bar.querySelector('[data-milestone="mini-gift"]');
      var label = miniMilestone ? miniMilestone.getAttribute('data-label') || '' : '';
      var remaining = config.miniThreshold - total;

      messageText = buildSpendMoreText(remaining, label);
    }
    else {
      var shippingMilestone = bar.querySelector('[data-milestone="free-shipping"]');
      var label = shippingMilestone ? shippingMilestone.getAttribute('data-label') || '' : '';
      var remaining = config.freeShippingThreshold - total;

      messageText = buildSpendMoreText(remaining, label);
    }

    messageElement.textContent = messageText;
  }

  function updateRewardItems(total) {
    var rewardContainers = document.querySelectorAll('[data-cart-rewards]');
    if (!rewardContainers.length) return;

    rewardContainers.forEach(function(container) {
      var miniItem = container.querySelector('[data-reward-type="mini_gift"]');
      var mysteryItem = container.querySelector('[data-reward-type="mystery_gift"]');

      if (miniItem) {
        initDrawer();

        var isUnlocked = total >= config.miniThreshold;
        miniItem.classList.toggle('cart-reward-item--disabled', !isUnlocked);

        var btn = miniItem.querySelector('[data-drawer-trigger]');
        if (btn) {
          btn.disabled = !isUnlocked;
        }

        if (isUnlocked) {
          var selected = getStorage(STORAGE_KEY_MINI);
          if (selected) {
            updateMiniDisplay(selected, miniItem);
          } else {
            var select = miniItem.querySelector('[data-reward-select]');
            var selectValue = select && select.value ? select.value : '';

            if (selectValue && selectValue !== '') {
              setStorage(STORAGE_KEY_MINI, selectValue);
              updateMiniDisplay(selectValue, miniItem);
            } else {
              var firstOption = miniItem.querySelector('[data-option-value]:not([data-option-none])');
              if (firstOption && firstOption.dataset.optionValue && firstOption.dataset.optionValue !== '') {
                var defaultVariantId = firstOption.dataset.optionValue;
                setStorage(STORAGE_KEY_MINI, defaultVariantId);
                updateMiniDisplay(defaultVariantId, miniItem);
              }
            }
          }
        } else {
          setStorage(STORAGE_KEY_MINI, '');
          resetMiniDisplay(miniItem);
        }
      }

      if (mysteryItem) {
        if (total >= config.mysteryThreshold) {
          mysteryItem.style.display = '';
        } else {
          mysteryItem.style.display = 'none';
        }
      }
    });
  }

  function updateMiniDisplay(variantId, item) {
    if (!item || !variantId) return;

    var option = item.querySelector('[data-option-value="' + variantId + '"]');
    if (!option) return;

    var img = item.querySelector('[data-reward-image-placeholder]');
    var title = item.querySelector('[data-reward-title-placeholder]');
    var selectorImg = item.querySelector('[data-selector-image-wrapper]');
    var selectorText = item.querySelector('[data-selector-text]');
    var priceOriginal = item.querySelector('[data-price-original]');
    var priceOriginalValue = item.querySelector('[data-price-original-value]');

    var imageUrl = option.dataset.imageUrlLarge || option.dataset.imageUrl;
    var selectorImageUrl = option.dataset.imageUrlSmall || option.dataset.imageUrl;
    var productTitle = option.dataset.productTitle || '';
    var variantTitle = option.dataset.variantTitle;
    var originalPrice = option.dataset.originalPrice || '';
    var fullTitle = variantTitle && variantTitle !== 'Default Title' 
      ? productTitle + ' - ' + variantTitle 
      : productTitle;

    if (img && imageUrl) {
      img.innerHTML = '<img src="' + imageUrl + '" alt="" style="width:100%;height:100%;object-fit:cover;">';
    }
    if (selectorImg && selectorImageUrl) {
      selectorImg.innerHTML = '<img src="' + selectorImageUrl + '" alt="" style="width:100%;height:100%;object-fit:cover;">';
    }
    if (title) title.textContent = fullTitle;
    if (selectorText) selectorText.textContent = fullTitle;

    if (priceOriginalValue && originalPrice) {
      priceOriginalValue.textContent = originalPrice;
      if (priceOriginal) {
        priceOriginal.style.display = '';
      }
    } else if (priceOriginal) {
      priceOriginal.style.display = 'none';
    }

    updateMiniGiftCartItem(option);
  }

  function resetMiniDisplay(item) {
    if (!item) return;

    var img = item.querySelector('[data-reward-image-placeholder]');
    var title = item.querySelector('[data-reward-title-placeholder]');
    var selectorImg = item.querySelector('[data-selector-image-wrapper]');
    var selectorText = item.querySelector('[data-selector-text]');

    var rewardsContainer = item.closest('[data-cart-rewards]');
    var selectGiftText = rewardsContainer ? rewardsContainer.getAttribute('data-text-select-gift') : '';
    var chooseGiftText = rewardsContainer ? rewardsContainer.getAttribute('data-text-choose-gift') : '';

    if (img) img.innerHTML = '';
    if (selectorImg) selectorImg.innerHTML = '';
    if (title) title.textContent = selectGiftText;
    if (selectorText) selectorText.textContent = chooseGiftText;

    resetMiniGiftCartItem();
  }

  function updateMiniGiftCartItem(option) {
    var cartGiftItems = document.querySelectorAll('[data-mini-gift-cart-item]');
    if (!cartGiftItems.length || !option) return;

    var imageUrl = option.dataset.imageUrlLarge || option.dataset.imageUrl;
    var variantUrl = option.dataset.variantUrl;
    var productTitle = option.dataset.productTitle || '';
    var variantTitle = option.dataset.variantTitle;
    var originalPrice = option.dataset.originalPrice || '';
    var fullTitle = variantTitle && variantTitle !== 'Default Title'
      ? productTitle + ' - ' + variantTitle
      : productTitle;

    cartGiftItems.forEach(function(cartGiftItem) {
      var link = cartGiftItem.querySelector('[data-mini-gift-link]');
      var title = cartGiftItem.querySelector('[data-mini-gift-title]');
      var variant = cartGiftItem.querySelector('[data-mini-gift-variant]');
      var image = cartGiftItem.querySelector('[data-mini-gift-image]');
      var original = cartGiftItem.querySelector('[data-mini-gift-original]');

      if (link && variantUrl) {
        link.href = variantUrl;
      }
      if (title) {
        title.textContent = fullTitle;
        if (variantUrl) {
          title.href = variantUrl;
        }
      }
      if (variant) {
        if (variantTitle && variantTitle !== 'Default Title') {
          variant.textContent = variantTitle;
          variant.classList.remove('hidden');
        } else {
          variant.textContent = '';
          variant.classList.add('hidden');
        }
      }
      if (image && imageUrl) {
        image.innerHTML = '<img src="' + imageUrl + '" alt="">';
      }
      if (original) {
        if (originalPrice) {
          original.textContent = originalPrice;
          original.classList.remove('hidden');
        } else {
          original.textContent = '';
          original.classList.add('hidden');
        }
      }

      cartGiftItem.classList.remove('hidden');
    });
  }

  function resetMiniGiftCartItem() {
    var cartGiftItems = document.querySelectorAll('[data-mini-gift-cart-item]');
    if (!cartGiftItems.length) return;

    cartGiftItems.forEach(function(cartGiftItem) {
      var link = cartGiftItem.querySelector('[data-mini-gift-link]');
      var title = cartGiftItem.querySelector('[data-mini-gift-title]');
      var variant = cartGiftItem.querySelector('[data-mini-gift-variant]');
      var image = cartGiftItem.querySelector('[data-mini-gift-image]');
      var original = cartGiftItem.querySelector('[data-mini-gift-original]');

      if (link) link.removeAttribute('href');
      if (title) {
        title.textContent = '';
        title.removeAttribute('href');
      }
      if (variant) {
        variant.textContent = '';
        variant.classList.add('hidden');
      }
      if (image) image.innerHTML = '';
      if (original) {
        original.textContent = '';
        original.classList.add('hidden');
      }

      cartGiftItem.classList.add('hidden');
    });
  }

  var drawerInitialized = false;

  function initDrawer() {
    var drawers = document.querySelectorAll('[data-reward-drawer]');
    if (!drawers.length) return;

    drawers.forEach(function(drawer) {
      var select = drawer.querySelector('[data-reward-select]');
      if (select) {
        var stored = getStorage(STORAGE_KEY_MINI);
        if (stored) {
          select.value = stored;
        } else {
          var selectedValue = select.value;
          if (selectedValue && selectedValue !== '') {
            setStorage(STORAGE_KEY_MINI, selectedValue);
          }
        }
      }
    });

    if (!drawerInitialized) {
      document.addEventListener('click', function(e) {
        var clickedTrigger = e.target.closest('[data-drawer-trigger]');
        if (!clickedTrigger) return;
        var drawer = clickedTrigger.closest('[data-reward-drawer]');
        if (!drawer) return;

        e.preventDefault();
        var currentPanel = drawer.querySelector('[data-drawer]');
        var currentTrigger = drawer.querySelector('[data-drawer-trigger]');
        if (currentPanel && currentTrigger) {
          var isOpen = currentPanel.getAttribute('aria-hidden') === 'false';
          currentPanel.setAttribute('aria-hidden', isOpen ? 'true' : 'false');
          currentTrigger.setAttribute('aria-expanded', isOpen ? 'false' : 'true');
        }
      });

      document.addEventListener('click', function(e) {
        var clickedOption = e.target.closest('[data-option-value]');
        if (!clickedOption) return;
        var drawer = clickedOption.closest('[data-reward-drawer]');
        if (!drawer) return;

        e.preventDefault();
        var variantId = clickedOption.dataset.optionValue || '';
        setStorage(STORAGE_KEY_MINI, variantId);

        var rewardsContainer = drawer.closest('[data-cart-rewards]');
        var miniItem = rewardsContainer ? rewardsContainer.querySelector('[data-reward-type="mini_gift"]') : null;
        if (variantId) {
          updateMiniDisplay(variantId, miniItem);
        } else {
          resetMiniDisplay(miniItem);
        }

        var currentPanel = drawer.querySelector('[data-drawer]');
        var currentTrigger = drawer.querySelector('[data-drawer-trigger]');
        if (currentPanel) {
          currentPanel.setAttribute('aria-hidden', 'true');
        }
        if (currentTrigger) {
          currentTrigger.setAttribute('aria-expanded', 'false');
        }
      });

      document.addEventListener('click', function(e) {
        var activeDrawer = e.target.closest('[data-reward-drawer]');
        if (activeDrawer) return;

        document.querySelectorAll('[data-reward-drawer]').forEach(function(drawer) {
          var currentPanel = drawer.querySelector('[data-drawer]');
          var currentTrigger = drawer.querySelector('[data-drawer-trigger]');
          if (currentPanel) {
            currentPanel.setAttribute('aria-hidden', 'true');
          }
          if (currentTrigger) {
            currentTrigger.setAttribute('aria-expanded', 'false');
          }
        });
      });

      drawerInitialized = true;
    }
  }

  function initMysteryToggle() {
    var toggle = document.querySelector('[data-mystery-gift-toggle]');
    if (!toggle) return;

    var stored = getStorage(STORAGE_KEY_MYSTERY);
    toggle.checked = stored !== 'false';

    toggle.addEventListener('change', function() {
      setStorage(STORAGE_KEY_MYSTERY, toggle.checked ? 'true' : 'false');
    });
  }

  var isProcessingCheckout = false;

  function handleCheckout(e) {
    var btn = e.target.closest('[data-checkout-button]');
    if (!btn) return;

    if (isProcessingCheckout) {
      e.preventDefault();
      log('⚠️ Checkout уже обрабатывается');
      return;
    }

    e.preventDefault();
    e.stopPropagation();
    isProcessingCheckout = true;
    
    log('=== CHECKOUT ===');

    var rewardsContainer = btn.closest('[data-cart-rewards]');
    var addingGiftsText = rewardsContainer ? rewardsContainer.getAttribute('data-text-adding-gifts') : '';

    btn.disabled = true;
    var originalText = btn.textContent;
    if (!btn.getAttribute('data-original-text')) {
      btn.setAttribute('data-original-text', originalText);
    }
    btn.textContent = addingGiftsText;

    fetchCart().then(function(cart) {
      var total = getCartTotal(cart);
      var selectedMini = getStorage(STORAGE_KEY_MINI);
      var mysteryEnabled = getStorage(STORAGE_KEY_MYSTERY) !== 'false';

      var shouldHaveMini = total >= config.miniThreshold && selectedMini;
      var shouldHaveMystery = total >= config.mysteryThreshold && mysteryEnabled;

      log('Валидация:', {
        total: total,
        shouldHaveMini: shouldHaveMini,
        shouldHaveMystery: shouldHaveMystery
      });

      return validateAndFixCart(cart, shouldHaveMini, selectedMini, shouldHaveMystery);
    }).then(function() {
      log('Переход на checkout');
      setStorage(STORAGE_KEY_MINI, '');
      window.location.href = '/checkout';
    }).catch(function(err) {
      log('Ошибка:', err);
      isProcessingCheckout = false;
      if (btn) {
        btn.disabled = false;
        var savedText = btn.getAttribute('data-original-text') || originalText;
        btn.textContent = savedText;
        btn.removeAttribute('data-original-text');
      }
    });
  }

  function validateAndFixCart(cart, shouldHaveMini, miniVariantId, shouldHaveMystery) {
    var promises = [];

    var hasMini = false;
    var hasCorrectMini = false;
    cart.items.forEach(function(item) {
      if (config.miniGiftProductIds.has(item.product_id)) {
        hasMini = true;
        var isSelectedVariant = String(item.id) === String(miniVariantId);
        if (isSelectedVariant) {
          hasCorrectMini = true;
        }

        if (!shouldHaveMini || item.quantity > 1 || (miniVariantId && !isSelectedVariant)) {
          log('Удаляем mini gift');
          promises.push(removeCartItem(item.key));
        }
      }
    });

    if (shouldHaveMini && miniVariantId && (!hasMini || !hasCorrectMini)) {
      log('Добавляем mini gift:', miniVariantId);
      promises.push(addCartItem(miniVariantId));
    }

    var hasMystery = hasGiftInCart(cart, config.mysteryGiftProductId);
    
    if (hasMystery && !shouldHaveMystery) {
      var key = getGiftKey(cart, config.mysteryGiftProductId);
      if (key) {
        log('Удаляем mystery gift');
        promises.push(removeCartItem(key));
      }
    }

    if (shouldHaveMystery && !hasMystery) {
      var mysteryScript = document.querySelector('[data-mystery-variant-id]');
      if (mysteryScript) {
        var variantId = parseInt(mysteryScript.dataset.mysteryVariantId);
        if (variantId) {
          log('Добавляем mystery gift:', variantId);
          promises.push(addCartItem(variantId));
        }
      }
    }

    return Promise.all(promises);
  }

  function watchCart() {
    var debounce = null;

    function check() {
      clearTimeout(debounce);
      debounce = setTimeout(function() {
        fetchCart().then(updateUI);
      }, 150);
    }

    document.addEventListener('cart:updated', check);
    document.addEventListener('cart:item-added', check);
    document.addEventListener('quick-cart:updated', check);

    var quickCart = document.querySelector('.quick-cart');
    if (quickCart) {
      var observer = new MutationObserver(check);
      observer.observe(quickCart, { 
        childList: true, 
        subtree: true,
        attributes: true,
        attributeFilter: ['aria-hidden']
      });
    }

    var cartForm = document.querySelector('.cart__form');
    if (cartForm) {
      cartForm.addEventListener('change', function(e) {
        if (e.target && e.target.name === 'updates[]') {
          check();
        }
      });

      cartForm.addEventListener('submit', function(e) {
        if (e.submitter && e.submitter.name === 'update') {
          setTimeout(check, 300);
        }
      });

      var removeButtons = cartForm.querySelectorAll('[data-remove-item]');
      removeButtons.forEach(function(button) {
        button.addEventListener('click', function() {
          setTimeout(check, 300);
        });
      });
    }
  }

  function init() {
    log('Инициализация...');

    isProcessingCheckout = false;
    
    resetCheckoutButton();

    var configLoaded = loadConfig();
    
    if (!configLoaded) {
      log('Конфигурация не загружена, запускаем наблюдатель...');
      watchForRewards();
    } else {
      log('✓ Конфигурация загружена');
    }

    initDrawer();
    initMysteryToggle();
    watchCart();

    document.addEventListener('click', function(e) {
      var checkoutBtn = e.target.closest('[data-checkout-button]');
      if (checkoutBtn) {
        var form = checkoutBtn.closest('form');
        if (form) {
          handleCheckout(e);
        }
      }
    }, true);

    fetchCart().then(updateUI);
    
    resetCheckoutButton();

    log('✓ Готово');
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    setTimeout(init, 100);
  }

  window.addEventListener('pageshow', function() {
    isProcessingCheckout = false;
    resetCheckoutButton();
  });

})();
